import Vue from 'vue';
import Router from 'vue-router';
import Login from '../components/Login.vue';
import PageClubInvoiceList from '../components/club/PageClubInvoiceList';
import PageClubInvoiceNew from '../components/club/PageClubInvoiceNew';
import PageClubInvoiceTransfer from '../components/club/PageClubInvoiceTransfer';
import PageClubInvoiceTransfers from '../components/club/PageClubInvoiceTransfers';
import PageClubInvoiceHistory from '../components/club/PageClubInvoiceHistory';
import PageClubInvoiceEvents from '../components/club/PageClubInvoiceEvents';
import PageClubTerminalList from '../components/club/PageClubTerminalList';
import PageClubTerminalHistory from '../components/club/PageClubTerminalHistory';
import PageClubTransfers from '../components/club/PageClubTransfers';
import store from '../store';

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next('/');
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next('/login');
};

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'Login',
      path: '/login',
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      name: 'PageClubInvoiceList',
      path: '/club/invoice/list',
      component: PageClubInvoiceList,
      beforeEnter: ifAuthenticated,
    },
    {
      name: 'PageClubInvoiceNew',
      path: '/club/invoice/new',
      component: PageClubInvoiceNew,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/club/invoice/transactions',
      name: 'PageClubInvoiceHistory',
      component: PageClubInvoiceHistory,
      beforeEnter: ifAuthenticated,
    },
    {
      name: 'PageClubInvoiceEvents',
      path :'/club/invoice/:id/events',
      component: PageClubInvoiceEvents,
      beforeEnter: ifAuthenticated,
    },
    {
      name: 'PageClubInvoiceTransfer',
      path: '/club/invoice/:id/transfer',
      component: PageClubInvoiceTransfer,
      beforeEnter: ifAuthenticated,
    },
    {
      name: 'PageClubInvoiceTransfers',
      path: '/club/invoice/:id/transfers',
      component: PageClubInvoiceTransfers,
      beforeEnter: ifAuthenticated,
    },
    {
      name: 'PageClubTerminalList',
      path: '/club/terminal/list',
      component: PageClubTerminalList,
      beforeEnter: ifAuthenticated,
    },
    {
      name: 'PageClubTerminalHistory',
      path: '/club/terminal/history',
      component: PageClubTerminalHistory,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/club/transfers',
      name: 'PageClubTransfers',
      component: PageClubTransfers,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '*',
      component: Login
    }
  ]
});
